import { Categories } from "emoji-picker-react";

const ORDER = [
	Categories.SUGGESTED,
	Categories.SMILEYS_PEOPLE,
	Categories.ANIMALS_NATURE,
	Categories.FOOD_DRINK,
	Categories.TRAVEL_PLACES,
	Categories.ACTIVITIES,
	Categories.OBJECTS,
	Categories.SYMBOLS,
	Categories.FLAGS,
];

// The picker ships English labels; these are its props in the current language.
export function emojiPickerLabels(t) {
	return {
		searchPlaceholder: t("comments:emoji.search"),
		previewConfig: { defaultCaption: t("comments:emoji.caption") },
		categories: ORDER.map((category) => ({
			category,
			name: t(`comments:emoji.categories.${category}`),
		})),
	};
}
